import { Tab, Tabs, Grid, Paper } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TabPanel } from '../../../components/tab-panel';
import { LotsTab } from './lots-tab/lots-tab';
import { ServicesBundleTab } from './services-bundle-tab/services-tab';
import { CustomerDetailsTab } from './project-contacts-tab/project-contacts-tab';
import { WorkOrdersTab } from './work-orders-tab/work-orders-tab';
import { PlanTab } from './plan-tab/plan-tabs';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';
import { ServicesTab } from './services-tab/services-tab';
import { Icons } from '../../../assets/icons';

interface DetailsTabs {
  customerID: any;
  officeID: any;
  permissionForTab: any;
  isNotCompleted: boolean;
  projectContact?: any[];
}
export const DetailsTabs = ({
  customerID,
  officeID,
  permissionForTab,
  isNotCompleted,
  projectContact,
}: DetailsTabs) => {
  const { projectID } = useParams();
  const [value, setValue] = useState('lots');
  const isDUXEnabled = process.env.REACT_APP_DUX_FLAG === 'true';
  const handleTabsChange = (event: any, value: any) => {
    setValue(value);
  };

  const availableTabs = useMemo(
    () =>
      [
        permissionForTab?.unitTab && 'lots',
        permissionForTab?.contactTab && 'contacts',
        permissionForTab?.serviceTab && 'services',

        permissionForTab?.workorders && 'workorders',
        permissionForTab?.serviceBundleTab && 'services-bundle',
        permissionForTab?.planTab && 'plans',
      ].filter(Boolean),
    [permissionForTab]
  );

  useEffect(() => {
    if (!availableTabs.includes(value)) {
      setValue(availableTabs[0] as string);
    }
  }, [availableTabs]);

  if (!projectID) {
    return <div>Invalid Project</div>;
  }

  const isPlanEnabled = process.env.REACT_APP_PLAN_FLAG === 'true';
  const isBundlePermission = useAuthorize([UserPermissionName?.VIEW_SERVICE_BUNDLE]);

  return (
    <Paper elevation={0} sx={{ mt: 2 }}>
      <Grid item>
        <Tabs value={value} onChange={handleTabsChange}>
          <Tab value="lots" label="Lots/Units" hidden={!permissionForTab?.unitTab} />
          <Tab value="contacts" label="Project Contacts" hidden={!permissionForTab?.contactTab} />
          <Tab value="services" label="Services" hidden={!permissionForTab?.serviceTab} />
          <Tab value="services-bundle" label=" Service  Bundles" hidden={!permissionForTab?.serviceBundleTab} />
          <Tab value="workorders" label="Work Orders" hidden={!permissionForTab?.workorders} />
          <Tab value="plans" label="Plans" hidden={!isPlanEnabled || !permissionForTab?.planTab} />
          {!!projectContact && projectContact?.length === 0 && isDUXEnabled && (
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '180px' }}>
              <span className="badge statusBadge  warning">
                {' '}
                <img src={Icons.IconWarning} /> Project Contacts required for DUX inspections
              </span>
            </div>
          )}
        </Tabs>

        {value === 'lots' && permissionForTab?.unitTab && (
          <TabPanel selectedValue={value} value="lots">
            <LotsTab isNotCompleted={isNotCompleted} projectID={Number(projectID)} />
          </TabPanel>
        )}
        {value === 'services-bundle' && permissionForTab?.serviceBundleTab && (
          <TabPanel selectedValue={value} value="services-bundle">
            <ServicesBundleTab isNotCompleted={isNotCompleted} projectID={Number(projectID)} />
          </TabPanel>
        )}
        {value === 'services' && permissionForTab?.serviceTab && (
          <TabPanel selectedValue={value} value="services">
            <ServicesTab projectID={Number(projectID)} />
          </TabPanel>
        )}
        {value === 'contacts' && permissionForTab?.contactTab && (
          <TabPanel selectedValue={value} value="contacts">
            <CustomerDetailsTab projectID={Number(projectID)} />
          </TabPanel>
        )}
        {value === 'workorders' && permissionForTab?.workorders && (
          <TabPanel selectedValue={value} value="workorders">
            <WorkOrdersTab
              projectID={Number(projectID)}
              customerID={!customerID ? 0 : customerID}
              officeID={officeID}
            />
          </TabPanel>
        )}
        {value === 'plans' && permissionForTab?.planTab && (
          <TabPanel selectedValue={value} value="plans">
            <PlanTab
              planRequestArgs={{
                customerID: Number(customerID),
                officeID: Number(officeID),
                projectID: Number(projectID),
              }}
            />
          </TabPanel>
        )}

      </Grid>
    </Paper>
  );
};
